module.exports = __webpack_public_path__ + "images/花筑pr长图_06-1.jpg?v=9e29db4e";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_06-1.jpg
 ** module id = 21
 ** module chunks = 1 2
 **/